<template>
<div id="messages">
	<header>
		<a href="#" @click.prevent="goBack" class="back"></a>
		<h1>{{ partner | name }}</h1>
	</header>
	<ul>
		<li v-for="message in messages" :class="{ mine: message.sender_id == user.id }">
			<p>{{ message.message }}</p>
		</li>
	</ul>
	<form id="send-message" @submit.prevent="send">
		<input type="text" v-model="message" ref="message">
		<input type="submit" value="Senden">
	</form>
</div>
</template>

<script>
import _ from 'underscore'
import Vue from 'vue'
import base from 'base.vue'

export default {
	mixins: [ base ],
	data () {
		return {
			partner: { },
			messages: [ ],
			message: '',
			updateTimer: '',
			scrollToBottomEnqueued: false
		}
	},
	methods: {
		fetchData () {
			const that = this
			
			return this.$api.get(`conversations/${this.$route.params.id}`)
			.then(response => {
				that.messages = response.data.messages
				that.partner = response.data.partner
				that.scrollToBottomEnqueued = true
			})
		},
		fetchNewData () {
			const that = this

			return this.$api.get(`conversations/${this.$route.params.id}`, {
				new: 1
			})
			.then(response => {
				that.messages = that.messages.concat(response.data.messages)

				if (response.data.messages.length > 0) {
					that.scrollToBottomEnqueued = true
				}
			})
			.finally(() => {
				that.updateTimer = setTimeout(that.fetchNewData, 2500)
			})
		},
		scrollToBottom () {
			const that = this
			const container = that.$el.querySelector("#messages > ul")
			container.scrollTop = container.scrollHeight
		},
		send () {
			const that = this
			const message = this.message

			this.$api.post(`conversations/${this.$route.params.id}/send`, {
				message: message
			})
			.then(response => {
				that.messages.push({
					message: message,
					sender_id: that.user.id
				})
				that.message = ''

				// Scroll to bottom
				that.scrollToBottomEnqueued = true
			})
		}
	},
	updated () {
		// We trigger scrollToBottom using a flag
		// This is necessary because the DOM is not yet available in fetchData()
		if (this.scrollToBottomEnqueued) {
			this.scrollToBottomEnqueued = false
			this.scrollToBottom()
		}
	},
	activated () {
		this.updateTimer = setTimeout(this.fetchNewData, 2500)

		// Necessary if same chat is re-opened in already existent component
		this.scrollToBottom()
	},
	deactivated () {
		clearTimeout(this.updateTimer)
	},
	beforeDestroy () {
		clearTimeout(this.updateTimer)
	}
}
</script>


// WEBPACK FOOTER //
// conversation.vue?32b58e8b